import { useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  useGetStorefrontMenus,
  useGetViewMenuDetail,
} from "../../hooks/api/queries";
import { useDispatch } from "react-redux";
import {
  resetMenuCartItems,
  setBusinessId,
  setMenuId,
} from "../../store/modules/menuCart";
import countriesList from "../../localdata/worldCountries.json";

export const useMenuPageLayout = () => {
  const { id } = useParams();
  const [search, setSearch] = useSearchParams();
  const businessIds = id?.split("-");
  const [tempMenuId, setTempMenuId] = useState(
    search.get("menu_id")
      ? search.get("menu_id")
      : businessIds?.length > 1
        ? id
        : null,
  );
  const { menuCartItems, menuId } = useSelector(
    (state) => state.menuCartReducer,
  );
  const [isActiveCart, setIsActiveCart] = useState(false);
  const [menuSearchText, setMenuSearchText] = useState(
    search.get("query") || "",
  );
  const [showCartItems, setShowCartItems] = useState(false);
  const [showLocationChange, setShowLocationChange] = useState(
    tempMenuId ? false : true,
  );
  const { isLoading: isLoadingMenuObjectDetail, data: menuObjectDetail } =
    useGetViewMenuDetail(tempMenuId);
  const { isLoading: isLoadingMenuObject, data: menuObject } =
    useGetStorefrontMenus(menuObjectDetail?.id);
  const dispatch = useDispatch();

  const primaryColor = menuObjectDetail?.primary_colour
    ? menuObjectDetail?.primary_colour
    : "#7647ee";

  const countryFlag = countriesList
    .filter((item) => item.countryCode !== "undefined")
    .find(
      (item) => item.name === menuObjectDetail?.store?.country,
    )?.countryFlag;

  const searchProduct = (value) => {
    if (value.length === 0) search.delete("query");
    else search.set("query", value);
    setSearch(search, { replace: true });
  };

  useEffect(() => {
    if (menuObjectDetail) {
      dispatch(setBusinessId(businessIds?.[0]));
      dispatch(setMenuId(menuObjectDetail?.id));
      const storedCartItems = localStorage.getItem(
        `menuCartItems${menuObjectDetail?.id}`,
      )
        ? JSON.parse(
            localStorage.getItem(`menuCartItems${menuObjectDetail?.id}`),
          )
        : [];

      dispatch(
        resetMenuCartItems(storedCartItems?.length > 0 ? storedCartItems : []),
      );
    }
  }, [menuObjectDetail]);

  useEffect(() => {
    if (!tempMenuId) setTempMenuId(menuId);
  }, [menuId]);

  return {
    primaryColor,
    countryFlag,
    isLoadingMenuObject,
    isLoadingMenuObjectDetail,
    menuCartItems,
    menuSearchText,
    showLocationChange,
    showCartItems,
    menuObject,
    menuObjectDetail,
    tempMenuId,
    isActiveCart,
    searchProduct,
    setIsActiveCart,
    setShowCartItems,
    setMenuSearchText,
    setShowLocationChange,
  };
};
